import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "highlighted-content-text" }

import ContentCard from '@src/components/patterns/ContentCard.vue';
import MembersIcon from '@src/components/shared/icons/MembersIcon.vue';
import ServiceTeamContact from '@src/components/shared/sidebar_cards/ServiceTeamContact.vue';

interface Props {
	assetsPath: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    assetsPath: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ServiceTeamContact, { "assets-path": __props.assetsPath }, null, 8, ["assets-path"]),
    _createVNode(ContentCard, { "is-sidebar-card": true }, {
      content: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t( 'membership_form_sidebar_title' )), 1)
        ]),
        _createVNode(MembersIcon, { class: "highlighted-icon" }),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t( 'membership_form_sidebar_text' )), 1)
      ]),
      _: 1
    })
  ], 64))
}
}

})